<template>
  <div v-if="viewport" class="interaction">
    <banner :nav-index="2">
      <template slot="banner">
        <div class="banner">
          <div class="center" :style="{'will-change': 'transform',transform: `translate3d(0,${transLateY}px,0)`}">
            <div class="text">
              <h1>
                Interactive Control
              </h1>
              <div class="line"></div>
              <p>The core of interactive control technology lies in advanced approaches such as brain-computer
                interfaces, muscle-machine interfaces, and hybrid interfaces. These methods collect and store individual
                thoughts and physical data, enabling the decoding of various types of cognitive and physiological
                information. By leveraging AI algorithms, the technology allows for the monitoring and classification of
                thought and bodily data, ultimately facilitating thought projection and control over external objects
                through human-machine interfaces. Building upon the decoding and re-encoding of thoughts, a virtual
                digital twin system is created, merging individual cognition and physical sensations.</p>
            </div>
          </div>
        </div>
      </template>
    </banner>
    <div style="position: relative;z-index: 2;background-color: #fff">
      <div class="drone">
        <img src="@/assets/inter_1.gif">
        <div class="content">
          <div class="title">Non-invasive BCI<br/>Mind-Control Interaction</div>
          <div class="sub">Internet-of-every-mind embodied by BCI and AI</div>
        </div>
      </div>

        <div class="lighta">
            <img src="@/assets/aashuai.gif">
            <div class="content">
                <div class="title">Invasive BCI system</div>
                <div class="sub">Combining brain-computer interface and AI algorithm to enable Memory Download and Decoding</div>
            </div>
        </div>



      <div class="light">
        <img src="@/assets/inter_2.gif">
        <div class="content">
          <div class="title">MCI Muscle-controlled Interaction</div>
          <div class="sub">Intelligent algorithms powering EMG-based wearables for a novel somatosensory interaction
            experience
          </div>
        </div>
      </div>
      <div class="footer-box">
        <relation></relation>
      </div>
    </div>
  </div>
  <div class="phone-wrap" v-else>
    <div class="background">
      <div class="nav">
        <div class="logo">
          <img src="@/assets/phone/phone-logo.png">
        </div>
        <div @click="onList" class="fork">
          <span class="iconfont icon-liebiaoshitucaidan"></span>
        </div>
      </div>
      <div class="title">
        <h1>Interactive Control</h1>
      </div>

      <div v-show="list" class="list">
        <phoneNav @onHide="onHide"></phoneNav>
      </div>
    </div>
    <div class="text">
      <p>The core of interactive control technology lies in advanced approaches such as brain-computer interfaces,
        muscle-machine interfaces, and hybrid interfaces. These methods collect and store individual thoughts and
        physical data, enabling the decoding of various types of cognitive and physiological information. By leveraging
        AI algorithms, the technology allows for the monitoring and classification of thought and bodily data,
        ultimately facilitating thought projection and control over external objects through human-machine interfaces.
        Building upon the decoding and re-encoding of thoughts, a virtual digital twin system is created, merging
        individual cognition and physical sensations.</p>
    </div>
    <div class="Bci">
      <div class="introduce">
        <div>
          <h3>Non-invasive BCI<br/>Mind-Control<br/>Interaction</h3>
          <p>Internet-of-every-mind<br/>embodied by BCI and AI</p>
        </div>
      </div>
    </div>


<!--      <div class="title">Invasive BCI system</div>-->
<!--      <div class="sub">Combining brain-computer interface and AI algorithm to enable Memory Download and Decoding</div>-->


      <div class="Mcib">
          <div class="introduce">
              <h3>Invasive BCI system</h3>
              <p>Combining brain-computer interface and AI algorithm to enable Memory Download and Decoding</p>
          </div>
      </div>

    <div class="Mci">
      <div class="introduce">
        <h3>MCI Muscle-controlled<br/> Interaction</h3>
        <p>Intelligent algorithms powering<br/>
          EMG-based wearables for a novel somatosensory interaction experience</p>
      </div>
    </div>
    <phoneFooter></phoneFooter>
  </div>
</template>

<script>
import banner from '@/components/banner'
import relation from '@/components/footer'
import phoneNav from '@/components/phoneNav/index'
import phoneFooter from "@/components/phoneFooter";

export default {
  name: "interaction.vue",

  components: {
    phoneNav,
    banner,
    relation,
    phoneFooter,
  },
  data() {
    return {
      toTop: 0,
      transLateY: 0,
      viewport: true,
      screenWidth: null,
      list: false,
    }

  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1024) {
        this.viewport = false
      } else {
        this.viewport = true
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
    this.screenWidth = document.body.clientWidth
    if (document.documentElement.clientWidth < 1280) {
      this.viewport = false
    }
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth

      })()
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {

    onList() {
      setTimeout(() => {
        this.list = true
      }, 200)

    },

    onHide() {
      setTimeout(() => {
        this.list = false
      }, 200)

    },

    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop < 900) {
        if (this.toTop <= scrollTop) {
          this.transLateY = scrollTop / 10
        } else {
          this.transLateY = -scrollTop / 10
        }
      }
      this.toTop = scrollTop
    }
  }
}
</script>

<style scoped>

.banner {
}

.center {
  width: 1200px;
  margin: 0 auto;
}

.center .text {
  padding-top: 110px;
}

.center .text h1 {
  font-weight: 700;
  font-size: 42px;
  line-height: 72px;
  color: #FFFFFF;
}

.center .text .line {
  margin-top: 42px;
  width: 60px;
  height: 6px;
  background-color: #FFFFFF;
}

.center .text p {
  margin-top: 50px;
  font-size: 24px;
  line-height: 50px;
  color: #FFFFFF;
  opacity: 0.8;
}

.drone {
  line-height: 0;
  position: relative;
}

.drone .content {
  width: 575px;
  position: absolute;
  right: 9.75%;
  top: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.drone .content .title {
  width: 700px;
  font-weight: 700;
  font-size: 56px;
  line-height: 82px;
  color: #111111;
}

.drone .content .sub {
  width: 700px;
  font-size: 24px;
  line-height: 50px;
  color: #111111;
  margin-top: 40px;
}

.drone img {
  width: 100%;
}

.light {
  line-height: 0;
  position: relative;
}

.light .content {
  position: absolute;
  right: 18.75%;
  top: 36%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.light .content .title {
  width: 668px;
  font-weight: 700;
  font-size: 56px;
  line-height: 82px;
  color: #fff;
}

.light .content .sub {
  padding-right: 27px;
  width: 668px;
  font-size: 24px;
  line-height: 50px;
  color: #fff;
  margin-top: 40px;
}

.light img {
  width: 100%;

}


.lighta {
    line-height: 0;
    position: relative;
}

.lighta .content {
    position: absolute;
    right: 51.75%;
    top: 38%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.lighta .content .title {
    width: 668px;
    font-weight: 700;
    font-size: 56px;
    line-height: 82px;
    color: #fff;
}

.lighta .content .sub {
    padding-right: 27px;
    width: 668px;
    font-size: 24px;
    line-height: 50px;
    color: #fff;
    margin-top: 40px;
}

.lighta img {
    width: 100%;

}



.muscle {
  line-height: 0;
  position: relative;
}

.muscle .content {
  position: absolute;
  left: 7%;
  top: 28%;
  display: flex;
  flex-direction: column;
}

.muscle .content .title {
  font-weight: 700;
  font-size: 56px;
  line-height: 82px;
  color: #111111;
}

.muscle .content .sub {
  font-size: 24px;
  line-height: 50px;
  color: #111111;
  width: 518px;
  margin-top: 40px;
}

.muscle img {
  width: 100%;
}

.phone-wrap {

}

.nav {
  display: flex;
  justify-content: space-between;
  padding: 1.14rem 0.6rem 0;
}

.nav .logo {
  display: flex;
  align-items: center;
  height: 0.43rem;
}

.nav .logo img {
  height: 0.35rem;
}

.nav .fork {
  color: #FFFFFF;
  line-height: 0.43rem;
  height: 0.43rem;
}

.nav .fork .iconfont {
  font-size: 0.36rem;
}

.list {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.background {
  background-image: url("../../assets/phone/interaction.jpg");
  background-repeat: no-repeat;
  /*background-size: 100% 100%;*/
  background-size: cover;
}

.background .title {
  padding: 1.84rem 0 2.06rem 0.7rem;
}

.background .title h1 {
  font-style: normal;
  font-weight: 700;
  font-size: 0.46rem;
  line-height: 0.61rem;
  color: #FFFFFF;
}

.phone-wrap .text {
  padding: 0.8rem 0.6rem 0.6rem;
}

.phone-wrap .text p {
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.4rem;
  color: #111111;
}

.Bci {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.2rem;
  padding: 2.69rem 0.46rem 1.11rem 0;
  background-image: url("../../assets/phone/BCI.gif");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center left 30%;
}

.Bci .introduce {
  display: flex;
  justify-content: flex-end;
}

.Bci .introduce h3 {
  width: 3.5rem;
  font-style: normal;
  font-weight: 600;
  font-size: 0.32rem;
  line-height: 0.45rem;
  color: #111111;
}

.Bci .introduce p {
  margin-top: 0.2rem;
  font-style: normal;
  width: 3.5rem;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.4rem;
  color: #111111;
}


.Mcib {
    padding: 1.92rem 0 1.48rem 2.28rem;
    background-image: url("../../assets/phone/aashuaiphone.gif");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center left 52%;
}

.Mcib .introduce h3 {
    font-weight: 600;
    font-size: 0.32rem;
    line-height: 0.45rem;
    color: #FFFFFF;
}

.Mcib .introduce p {
    margin-top: 0.2rem;
    width: 4.6rem;
    font-style: normal;
    font-weight: 400;
    font-size: 0.24rem;
    line-height: 0.4rem;
    color: #FFFFFF;
}



.Mci {
  padding: 1.92rem 0 1.48rem 2.28rem;
  background-image: url("../../assets/phone/MCI.gif");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center left 52%;
}

.Mci .introduce h3 {
  font-weight: 600;
  font-size: 0.32rem;
  line-height: 0.45rem;
  color: #FFFFFF;
}

.Mci .introduce p {
  margin-top: 0.2rem;
  width: 5.1rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.4rem;
  color: #FFFFFF;
}

.Hci {
  padding: 1.95rem 0 1.05rem 3.68rem;
  background-image: url("../../assets/phone/HCI.gif");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center left 76%;
  display: flex;
  justify-content: flex-end;
}

.Hci .introduce h3 {
  width: 2.68rem;
  font-weight: 600;
  font-size: 0.32rem;
  line-height: 0.45rem;
  color: #111111;
}

.Hci .introduce p {
  margin-top: 0.2rem;
  width: 4rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.4rem;
  color: #111111;
}
</style>
